import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Layout from "./layout";
import SearchIcon from "@mui/icons-material/Search";
import TableSortLabel from "@mui/material/TableSortLabel";
import DownloadIcon from "@mui/icons-material/Download";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { jsPDF } from "jspdf";
import jhsLogo from "../images/jhsLogo.png";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { DialogActions, DialogContentText } from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import "jspdf-autotable";
import "../App.css";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from '@mui/material';
import { useAcademicYear } from "./AcademicYearContext"
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import KitPayment from './KitsPayment';
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { getInstituteConfig } from "../utility/instituteConfig";



export default function IssueKits() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [search, setSearch] = useState("");
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("assigned_kit_id");
  const [open, setOpen] = useState(false);
  const [statusName, setStatusName] = useState("");
  const [userId, setUserId] = useState("");
  const [loading, setLoading] = useState(false); // Loading state

 
  
  const [isStoreOpen, setIsStoreOpen] = useState(false);


  const [selectedStudent, setSelectedStudent] = useState('');
  const [selectedKit, setSelectedKit] = useState();
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);
  const [status, setStatus] = useState([]);
  const [assignedKits, setAssignnedKits] = useState([]);
  const [kitProducts, setKitProducts] = useState([{}]);
  const [assignedKitId, setAssignnedKitId] = useState();
  const [userMail, setUserMail] = useState();
  const [refundBalance, setRefundBalance] = useState();
  const [dialogType, setDialogType] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [checkBoxOpen, setCheckBoxOpen] = React.useState(false);
  const [statusId, setStatusId] = useState();
  const [kitName, setKitName] = useState();
  const [kitId, setKitId] = useState();
  const [kitQuantity, setKitQuantity] = useState();
 
  const navigate = useNavigate();
  
   const { academicYearId } = useAcademicYear();
   const instituteId = localStorage.getItem("instituteId");
  
    useEffect(() => {
      console.log("Received Academic Year ID:", academicYearId);
    }, [academicYearId]);

  const handleDownload = (row) => {
    // Prevent download if rows are empty or all rows contain no meaningful data
    const isDataEmpty = !assignedKits || assignedKits.length === 0 || assignedKits.every(row =>
      !row.assigned_kit_id,
      !row.student_name !== " " ? !row.student_name : !row.staff_name,
      !row.staff_roles || !row.student_role,
      !row.student_contact_no || !row.staff_contact_no,
      !row.kit_name,
      !row.payment_date,
      !row.issue_date,
      !row.issued_by_name,
      !row.kit_status,
      !row.total_price,
    );

    if (isDataEmpty) {
      return;
    }
    const doc = new jsPDF();

   const institute = getInstituteConfig(instituteId);
  
      // Header background
      doc.setFillColor("#0A64A2");
      const headerHeight = 20;
      doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");
  
      // Logo
      if (institute.logo) {
        doc.addImage(institute.logo, "PNG", 9, 1, 28, 18);
      }
  
      // School Name
      const textStartY = 11;
      doc.setFontSize(14);
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.text(institute.name, doc.internal.pageSize.getWidth() / 2, textStartY, {
        align: "center",
      });
  
      // Address
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");
      doc.text(
        institute.address1,
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 14,
        { align: "center" },
      );
      doc.text(
        institute.address2,
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 18,
        { align: "center" },
      );
      if (institute.tel) {
        doc.text(
          institute.tel,
          doc.internal.pageSize.getWidth() / 2,
          textStartY + 22,
          { align: "center" },
        );
      }
    // Add Receipt Title, Number, and Date - Right aligned
    const receiptTextY = textStartY + 36; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "ISSUE KIT REPORT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" }
    ); // Center aligned title // Center aligned title
    doc.setFontSize(10);

    let studentDetailsY = receiptTextY + 10; // Adjust Y position after receipt info

    // Set font for student name and details
    doc.setFont('helvetica', 'bold');

    // Date
    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}/${String(currentDate.getMonth() + 1).padStart(2, '0')}/${currentDate.getFullYear()}`;
    doc.setFont('helvetica', 'bold');
    doc.text(`Date: `, 169, studentDetailsY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${formattedDate}`, 178, studentDetailsY);

    const totalAmount = assignedKits.reduce((sum, row) => {
      const price = row.kit_price ? parseFloat(row.kit_price.replace(/[^0-9.]/g, '')) : 0;
      return sum + price;
    }, 0);

    const tableData = assignedKits.map((row) => {


      return [
        row.assigned_kit_id,
        row.student_name !== " " ? row.student_name : row.staff_name,
        row.staff_roles || row.student_role,
        row.student_contact_no || row.staff_contact_no,
        row.kit_name,
        row.payment_date,
        row.issue_date,
        row.issued_by_name,
        row.kit_status,
        row.kit_price ? row.kit_price.replace(/[^0-9.]/g, '') : "0.00",
        totalAmount.toLocaleString(),
      ];
    });

    tableData.push([
      "", // Empty for Student ID
      "", // Label for the totals
      "", // Empty for Fees Slab
      "", // Empty for Parent Name
      "", // Grand total label
      "", // Total Amount Paid
      "", // Total Amount Pending
    ]);
    tableData.push([
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Total:",
      totalAmount,
    ]);

    // Table settings
    doc.autoTable({
      head: [
        [
          "Indent ID",
          "Name",
          "Role",
          "Contact No",
          "Kit Name",
          "Payment Date",
          "Issue Date",
          "Issued By ",
          "Status",
          "Total Amount",

        ],
      ],
      body: tableData,
      startY: receiptTextY + 13,// Adjusted based on dynamic content
      styles: { fontSize: 8, halign: 'center' },
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
        alignItems: 'center',
      },
      theme: "grid",
      // Make the last row (Grand Total) bold
      didParseCell: (data) => {
        if (data.row.index === tableData.length - 1) { // Check if it's the last row
          data.cell.styles.fontStyle = 'bold'; // Set font style to bold
        }
      },
    });
    // Save the PDF
    doc.save(`issue_kit_report_${new Date().toISOString().slice(0, 10)}.pdf`);
  };

 //download reciept
 const handleDownloadReciept =async (row, event) => {
  event.stopPropagation();
  const doc = new jsPDF();

  // Load the school logo as a base64 string or URL
  const institute = getInstituteConfig(instituteId);
  
      // Add Logo and Header
      doc.setFillColor("#0A64A2");
      const headerHeight = 20;
      doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");
      doc.setFontSize(14);
      doc.setTextColor(255, 255, 255);
      const textyy = 11;
      doc.setFont("helvetica", "bold");
  
      // School name
      doc.text(
        institute.name,  // ✅ dynamic
        doc.internal.pageSize.getWidth() / 2,
        textyy,
        { align: "center" }
      );
  
      // Logo
      if (institute.logo) {
        doc.addImage(institute.logo, "PNG", 8, 1, 28, 18);  // ✅ dynamic
      }
  
      // Address
      doc.setTextColor(0, 0, 0);
      const textStartY = 15;
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(
        institute.address1,  // ✅ dynamic
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 10,
        { align: "center" }
      );
      doc.text(
        institute.address2,  // ✅ dynamic
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 14,
        { align: "center" }
      );
      if (institute.tel) {
        doc.text(
          institute.tel,  // ✅ dynamic, skipped for JPS
          doc.internal.pageSize.getWidth() / 2,
          textStartY + 18,
          { align: "center" }
        );
      }
  
  // Add Receipt Title, Number, and Date - Right aligned
  const receiptTextY = textStartY + 30; // Position the receipt content slightly lower
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  if (row.kit_status === "Paid") {
    doc.text(
      "KIT PROCUREMENT RECEIPT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" }
    ); // Center aligned title
  } else {
    doc.text(
      "ISSUE KIT RECEIPT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" }
    ); // Center aligned title
  }
  doc.setFontSize(10);



  //Constants for alignment
  const studentLabelX = 14;
  const grade = `${row.student_name !== " " ? row.student_name : row.staff_name} `;
  const feesSlab = `${row.student_role || row.staff_roles || ""}`;
  const feesPending = `${row.student_grade || ""}`;  
  const section = `${row.student_section || ""}`;  



  // Add Grade, Fees Slab, Pending Fees, and Section dynamically
  const studentDetailsY = receiptTextY + 10;

  // Set font for student name and details
  doc.setFont('helvetica', 'bold');

  // Handle long student name (Grade)
  const gradeWidth = doc.getTextWidth(grade);  // Get width of grade text
  const maxGradeWidth = 70;  // Max width before wrapping
  const splitGrade = gradeWidth > maxGradeWidth ? doc.splitTextToSize(grade, maxGradeWidth) : grade;

  doc.text(`Name: `, studentLabelX, studentDetailsY);  // Left aligned
  doc.setFont('helvetica', 'normal');
  doc.text(splitGrade, studentLabelX + 11, studentDetailsY);  // Adjust X position for grade

  // Dynamically calculate X position for Fees Slab based on Grade length
  const gradeXEnd = studentLabelX + 13 + (gradeWidth > maxGradeWidth ? maxGradeWidth : gradeWidth) + 5;  // End of grade text + 10 for padding

  // Set font and add Fees Slab
  doc.setFont('helvetica', 'bold');
  doc.text('Role: ', gradeXEnd, studentDetailsY);  // Start after grade
  doc.setFont('helvetica', 'normal');
  const feesSlabWidth = doc.getTextWidth(feesSlab);  // Calculate width of fees slab
  doc.text(feesSlab, gradeXEnd + 9, studentDetailsY);  // Position fees slab with dynamic spacing

  // Dynamically calculate X position for Pending Fees based on Fees Slab length
  const feesSlabXEnd = gradeXEnd + 10 + feesSlabWidth + 5;  // End of fees slab text + 10 for padding

  // Set font and add Pending Fees
  doc.setFont('helvetica', 'bold');
  doc.text('Grade: ', feesSlabXEnd, studentDetailsY);  // Start after fees slab
  doc.setFont('helvetica', 'normal');
  const pendingFeesWidth = doc.getTextWidth(feesPending);  // Calculate width of pending fees
  doc.text(feesPending, feesSlabXEnd + 12, studentDetailsY);  // Adjust X position for pending fees

  // Dynamically calculate X position for Section based on Pending Fees length
  const pendingFeesXEnd = feesSlabXEnd + 15 + pendingFeesWidth + 5;  // End of pending fees text + 10 for padding

  // Set font and add Section
  doc.setFont('helvetica', 'bold');
  doc.text('Section: ', pendingFeesXEnd, studentDetailsY);  // Start after pending fees
  doc.setFont('helvetica', 'normal');
  doc.text(section, pendingFeesXEnd + 14, studentDetailsY);  // Adjust X position for section
  // Table for Particulars (example data)
  const receiptDetails = [
    { title: "Indent ID", value: row.assigned_kit_id },
    { title: "Kit Name", value: row.kit_name },
    { title: "Contact No", value: row.student_contact_no || row.staff_contact_no },
      { title: "Amount Paid", value: row.amount_paid.replace(/[^0-9.]/g, '') },
    { title: "Payment Date", value: row.payment_date },
    { title: "Issued By", value: row.issued_by_name },
    { title: "Issue Date", value: row.issue_date },
    { title: "Quantity", value: row.quantity },
    // { title: "Total Amount",value: row.total_price ? row.total_price.replace(/[^0-9.]/g, '') : "0.00"   },
    { title: "Status", value: row.kit_status },



  ];

const kitProductsData = await getKitProducts(row.kit_id); // this needs to be awaited if it's async
const productsList = (kitProductsData?.kitProduct || []).map((product, index) => {
return `${index + 1}. Product: ${product.product_name},  Quantity: ${product.quantity},  Price: ${product.price}`;
});

// Push into receiptDetails
receiptDetails.push({ title: "Product List", value: productsList.join("\n") });

  doc.autoTable({
    head: [["Particulars", "Amount"]],
    body: receiptDetails.map((item) => {
      if (item.title === "Status") {
        return [
          { content: item.title, styles: { fontStyle: "normal" } }, // Bold title
          { content: item.value, styles: { fontStyle: "bold" } }, // Bold value
        ];
      } else {
        return [item.title, item.value]; // Normal styling for other rows
      }
    }),
    startY: receiptTextY + 13, // Start table below student details
    styles: { fontSize: 10, cellPadding: 2 }, // Adjust padding for consistency
    headStyles: {
      fillColor: "#0A64A2", // Blue header
      textColor: [255, 255, 255], // White text
      halign: "left", // Center-align header text
    },
    bodyStyles: {
      halign: "left", // Align text to the left in the body
    },
    columnStyles: {
      0: { cellWidth: 70, halign: "left" }, // Narrower left column
      1: { cellWidth: 110, halign: "left" }, // Wider right column
    },
    theme: "grid",
  });
  const currentDate = new Date();

  // Format the date as DD/MM/YYYY
  const formattedDate = `${String(currentDate.getDate()).padStart(
    2,
    "0"
  )}/${String(currentDate.getMonth() + 1).padStart(
    2,
    "0"
  )}/${currentDate.getFullYear()}`;

 


  if (row.kit_status === "Paid") {
  doc.setFont("helvetica", "bold");
  doc.text("Accountant Signature", 14, doc.previousAutoTable.finalY + 40);
  doc.setFont("helvetica", "bold");
  doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 50);
  doc.setFont("helvetica", "bold");
  doc.text("Issuer Signature", 167, doc.previousAutoTable.finalY + 40);
  doc.setFont("helvetica", "bold");
  doc.text("Date:", 167, doc.previousAutoTable.finalY + 50);
  }else{
 // Add the text with the current date
 doc.setFont("helvetica", "bold");
 doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 40);
 doc.setFont("helvetica", "bold");
 doc.text("Authorized Signatory", 158, doc.previousAutoTable.finalY + 40); // Right aligned for signature
  }
  // Save the PDF
  if (row.kit_status === "Paid") {
    doc.save(
      `kit-procurement-receipt_${new Date().toISOString().slice(0, 10)}.pdf`
    );
  } else {
    doc.save(
      `issue-kit-receipt_${new Date().toISOString().slice(0, 10)}.pdf`
    );
  }
};

  const handleStatusChange = (event) => {
    setStatusName(event.target.value);
    let kitStatusId = status.find(
      (s) => s.description === event.target.value
    );
    setStatusId(kitStatusId.sales_status_id);
  };

  const handleCheckboxClick = async(row) => {
    setKitId(row.kit_id);
    setKitQuantity(row.quantity);
    const kitProductData = await getKitProducts(row.kit_id);

    // Handle different statuses
    if (row.kit_status === "Created") {
      setDialogMessage(
        `Kit cannot be issued because the payment for Indent ID ${row.assigned_kit_id} has not been completed.`
      );
      setDialogType("info");
      setCheckBoxOpen(true);
      return;
    } else if (row.kit_status === "Paid") {
      setCheckBoxOpen(true);
      setDialogMessage(
        `Are you sure you want to update status for Indent ID ${row.assigned_kit_id} from "Paid" to "Issued"?`
      );
      setDialogType("confirmation");
    }

    // Store the sales ID for use later
    setAssignnedKitId(row.assigned_kit_id);

    if (row.kit_status === "Paid" && row.kit_quantity === 0) {
      setDialogMessage(
        `Kit cannot be issued as stock is not available for kit ID ${row.kit_id}.`
      );
      setDialogType("error");
      setCheckBoxOpen(true);
      return;
    }
    if (
      row.kit_status === "Paid" &&
      kitProductData?.kitProduct &&
      kitProductData.kitProduct.some(
        (item) => parseInt(item.quantity) > parseInt(item.product_quantity)
      )
    ) {
      const invalidProducts = kitProductData.kitProduct.filter(
        (item) => parseInt(item.quantity) > parseInt(item.product_quantity)
      );
     // If no products have insufficient stock, don't show the error message
  if (invalidProducts.length === 0) return;
      const productDetails = invalidProducts
        .map(
          (p) => `${p.product_name.trim()} (ID: ${p.product_id})`
        )
        .join(", ");
    
      setDialogMessage(
        `Kit cannot be issued as stock is not available for the following product(s): ${productDetails}.`
      );
      setDialogType("error");
      setCheckBoxOpen(true);
      return;
    }
    
    setCheckBoxOpen(true);
  };
  const handleIssueKit = async () => {
    setCheckBoxOpen(false);

    try {
           // Wait for kit products to be fetched
    const kitProductsData = await getKitProducts(kitId);
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/updatKitStatus",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            assigned_kit_id: assignedKitId,
            issue_date: new Date(),
            issued_by: userId,
            kit_id: kitId,
            quantity:kitQuantity,
            kitProducts:kitProductsData,

          }),
        }
      );

    } catch (error) {
      console.error("Error fetching  details:", error);
    }
    getAssignedKit();
    setKitProducts([]);

  };

  const closeCheckBox = () => {
    setCheckBoxOpen(false);
    setKitProducts([]);
  };
  
    useEffect(() => {
    getAssignedKit();
  }, []);
  useEffect(() => {
    getAssignedKit();
  }, [statusId, academicYearId]);
  useEffect(() => {
    getAssignedKit();
  }, [academicYearId]);

  const getAssignedKit = async () => {
    setLoading(true);
    
    try {
  
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/getIssueKit",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            kit_status_id: statusId || null,
            academic_year_id: academicYearId,

          }),
        }

      );
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return null; // Stop further execution
      }
      const data = await response.json();
      
      setAssignnedKits(data);
    

    } catch (error) {
      console.error("Error fetching  details:", error);
    } finally {
      setLoading(false); // Ensure loading is set to false when done
    }
  };


  const getKitProducts = async (kitId) => {
    try {
     
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/getKitProduct",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            kit_id: kitId,

          }),
        }
      );
      const data = await response.json();
      setKitProducts(data);
      setKitName(data?.kitProduct[0]?.kit_name)

      return data; // Return the data for further processing if needed
    } catch (error) {
      console.error("Error fetching  details:", error);
    }
  };
  const handleProductList = (kitId) => {
    getKitProducts(kitId);
    setOpen(true);
  }
  const handleCloseProducts = () => {
    setOpen(false)
    setKitProducts([]);
  };
  const totalProductPrice = (kitProducts?.kitProduct || []).reduce((sum, p) => {
    return sum + (parseFloat(p.price) * p.quantity); // Ensure price is numeric
  }, 0);



  const handleSelectRow = (
    (assigned_kit_id,
      student_id, staff_id,
      staff_name,
      student_name,
      student_role,
      staff_roles,
      student_grade,
      student_section, kit_id,
      total_price, kit_name, kit_description, quantity, kit_quantity
    ) => {

      setAssignnedKitId(assigned_kit_id);
      setIsStoreOpen(true);
      setSelectedStudent({
        id: student_id || staff_id,
        name: student_name && student_name.trim() !== "" ? student_name : staff_name,
        role: student_role || staff_roles,
        grade: student_grade,
        section: student_section
      })


      setSelectedKit({
        kit_description: kit_description,
        kit_id: kit_id,
        kit_name: kit_name,
        kit_quantity: kit_quantity,
        maxQuantity: quantity,
        quantity: quantity,
        total_price: total_price
      })
getKitProducts(kit_id);
    });

  const getSaleStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getSalesStatus`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      // Get only the first 3 values
      const filteredData = data.slice(0, 3);
      setStatus(filteredData);


    } catch (error) {
      console.error("Error fetching sales status:", error);
    }
  };

  useEffect(() => {
    getSaleStatus();
  }, []);



  const handleModelClose = (event) => {
    setIsStoreOpen(false);
    getAssignedKit();
  };



  useEffect(() => {
    const fetchUserData = async () => {

      const email = localStorage.getItem('user_email');
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { 'user_email': email }, }
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
          setUserMail(response.data.user.email_id)


        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  //Arohi
  //Added Sorting and Pagination
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Sorting comparator
  const comparator = (a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    }
    return a[orderBy] > b[orderBy] ? -1 : 1;
  };

  // const filteredData = (assignedKits || []).filter((row) => {
  //   const searchTerm = search.trim().toLowerCase(); // Trim spaces and convert search term to lowercase

  //   // Check if the search term is empty to include all rows
  //   if (!searchTerm) return true;

  //   // Split the search term into words
  //   const searchWords = searchTerm.split(/\s+/); // Split by spaces

  //   // Check if all search words are included in any of the fields
  //   return searchWords.every((word) => {
  //     return (
  //       (row.staff_name?.toLowerCase() || "").includes(word) ||
  //       (row.student_name?.toLowerCase() || "").includes(word) ||
  //       (row.staff_roles?.toLowerCase() || "").includes(word) ||
  //       (row.student_role?.toLowerCase() || "").includes(word) ||
  //       (row.staff_contact_no?.toString() || "").includes(word) ||
  //       (row.student_contact_no?.toLowerCase() || "").includes(word) ||
  //       (row.isuue_date?.toString() || "").includes(word) ||
  //       (row.payment_date?.toString() || "").includes(word) ||
  //       (row.issued_by_name?.toLowerCase() || "").includes(word) ||
  //       (row.assigned_kit_id?.toString() || "").includes(word) ||
  //       (row.kit_name?.toLowerCase() || "").includes(word) ||
  //       (row.total_price?.replace(/[^0-9.]/g, '').toLowerCase() || "").includes(word) ||
  //       (row.kit_status?.toLowerCase() || "").includes(word)
  //     );
  //   });
  // });
  const filteredData = Array.isArray(assignedKits)
  ? assignedKits.filter((row) => {
      const searchTerm = search.trim().toLowerCase();

      if (!searchTerm) return true;

      const searchWords = searchTerm.split(/\s+/);

      return searchWords.every((word) => {
        return (
          (row.staff_name?.toLowerCase() || "").includes(word) ||
          (row.student_name?.toLowerCase() || "").includes(word) ||
          (row.staff_roles?.toLowerCase() || "").includes(word) ||
          (row.student_role?.toLowerCase() || "").includes(word) ||
          (row.staff_contact_no?.toString() || "").includes(word) ||
          (row.student_contact_no?.toLowerCase() || "").includes(word) ||
          (row.issue_date?.toString() || "").includes(word) ||
          (row.payment_date?.toString() || "").includes(word) ||
          (row.issued_by_name?.toLowerCase() || "").includes(word) ||
          (row.assigned_kit_id?.toString() || "").includes(word) ||
          (row.kit_name?.toLowerCase() || "").includes(word) ||
          (row.total_price?.replace(/[^0-9.]/g, '').toLowerCase() || "").includes(word) ||
          (row.kit_status?.toLowerCase() || "").includes(word)
        );
      });
    })
  : [];

  // Apply sorting to filtered data
  const sortedRows = [...filteredData].sort(comparator);

  // Apply pagination to the sorted data
  const paginatedRows = sortedRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );



  return (
    <div style={{ padding: 20 }}>
      <Layout />

      <div>
        <h1 className="fees_management_title">Kit Payment</h1>
      </div>

      <Stack spacing={2} direction="row" mb={2}>
        <Button

          variant="outlined"

          onClick={() => {
            navigate("/fees-report");
          }}
        >
          Fees
        </Button>
        <Button
          variant="outlined"

          onClick={() => {
            navigate("/fees-slab");
          }}
        >
          Fees Slab
        </Button>
        <Button
          className="save_update_btn"
          variant="contained"
          onClick={() => {
            navigate("/kit-payment-management");
          }}
        >
          Kit payment
        </Button>
      </Stack>
      {/* <br /> */}
      <div className="fees_report_box">
        <Stack spacing={4} direction="row">
          <Stack direction="row" spacing={2} alignItems="center">
            {" "}
            {/* Search Box */}
            <Box component="form" className="search-box">
              <TextField
                label="Search..."
                variant="outlined"
                fullWidth
                value={search}
                onChange={(event) => {
                  setSearch(event.target.value)
                  setPage(0); // Reset to first page
                }}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        type="button"
                        sx={{ p: "10px" }}
                        aria-label="search"
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box sx={{ minWidth: 100 }}>
              <FormControl sx={{ minWidth: 100 }} size="small">
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={statusName}
                  label="Grade"
                  onChange={handleStatusChange}
                >
                  {status.map((s) => (
                    <MenuItem key={s.description} value={s.description}>
                      {s.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

          </Stack>
          <div className="download-report-box-fees-report">

            <Button
              className="create-sale-btn"
              // sx={{background:'#0A64A2',padding:"7.5px"}}
              variant="contained"
              onClick={handleDownload}
              startIcon={<DownloadIcon />}
            >
              Download Report
            </Button>
          </div>
        </Stack>
      </div>
      {/* <br /> */}

      <Box className="table-container">
        <Box className="table-container">
          <Paper className="table-container-paper">
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 750 }}
                aria-label="custom pagination table"
              >
                <TableHead align="center">
                  <TableRow>
                    <StyledTableCell
                      sortDirection={orderBy === "issue_product_id" ? order : false}
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "assigned_kit_id"}
                        direction={orderBy === "assigned_kit_id" ? order : "asc"}
                        onClick={() => handleRequestSort("assigned_kit_id")}
                      >
                        Indent ID
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      sortDirection={orderBy === "student_name" ? order : false}
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "student_name"}
                        direction={orderBy === "student_name" ? order : "asc"}
                        onClick={() => handleRequestSort("student_name")}
                      >
                        Name
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      sortDirection={orderBy === "staff_name" ? order : false}
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "staff_name"}
                        direction={orderBy === "staff_name" ? order : "asc"}
                        onClick={() => handleRequestSort("staff_name")}
                      >
                        Role
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "34px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "student_contact_no"}
                        direction={orderBy === "student_contact_no" ? order : "asc"}
                        onClick={() => handleRequestSort("student_contact_no")}
                      >
                        Contact No
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "kit_name"}
                        direction={orderBy === "kit_name" ? order : "asc"}
                        onClick={() => handleRequestSort("kit_name")}
                      >
                        Kit Name
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "payment_date"}
                        direction={orderBy === "payment_date" ? order : "asc"}
                        onClick={() => handleRequestSort("payment_date")}
                      >
                        Payment Date
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issue_date"}
                        direction={orderBy === "issue_date" ? order : "asc"}
                        onClick={() => handleRequestSort("issue_date")}
                      >
                        Issue Date
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issued_by_name"}
                        direction={
                          orderBy === "issued_by_name" ? order : "asc"
                        }
                        onClick={() => handleRequestSort("issued_by_name")}
                      >
                        Issued By
                      </TableSortLabel>
                    </StyledTableCell>
                    {/* <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "34px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "total_price"}
                        direction={orderBy === "total_price" ? order : "asc"}
                        onClick={() => handleRequestSort("total_price")}
                      >
                        Total Amount
                      </TableSortLabel>
                    </StyledTableCell> */}

                    <StyledTableCell align="center" className="sales_tablecell">
                      <TableSortLabel
                        active={orderBy === "kit_status"}
                        direction={orderBy === "kit_status" ? order : "asc"}
                        onClick={() => handleRequestSort("kit_status")}
                      >
                        Status
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Issued
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Product
                    </StyledTableCell>

                    <StyledTableCell align="center" className="sales_tablecell">
                      Receipt
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={12} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {paginatedRows.map((row) => (
                      <StyledTableRow
                        style={{ cursor: "pointer", textAlign: "center" }}
                        key={row.assigned_kit_id}
                        tabIndex={-1}
                        padding="none"
                        // onClick={handleSelectRow()}

                        onClick={(event) => {
                          // Check if the clicked element is inside an ignored component
                          if (
                            event.target.closest(".receipt-icon") ||
                            event.target.closest(".product-icon") ||
                            event.target.type === "checkbox"
                          ) {
                            return; // Ignore click
                          }

                          handleSelectRow(
                            row.assigned_kit_id, row.student_id, row.staff_id, row.staff_name,
                            row.student_name, row.student_role, row.staff_roles,
                            row.student_grade, row.student_section, row.kit_id,
                            row.total_price, row.kit_name, row.kit_description,
                            row.quantity, row.kit_quantity
                          );
                        }}

                      >
                        <StyledTableCell
                          component="th"
                          scope="row"
                          padding="none"
                          align="center"
                          className="table_content" >
                          {row.assigned_kit_id}
                        </StyledTableCell>
                        <StyledTableCell
                          component="th"
                          scope="row"
                          padding="none"
                          align="center"
                          className="table_content" >
                          {row.student_name !== " " ? row.student_name : row.staff_name}
                        </StyledTableCell>
                        <StyledTableCell align="center" className="table_content" >
                          {row.staff_roles || row.student_role}
                        </StyledTableCell>

                        <StyledTableCell align="center" className="table_content" >
                          {row.staff_contact_no || row.student_contact_no}
                        </StyledTableCell>
                        <StyledTableCell align="center" className="table_content"
                        >
                          {row.kit_name}
                        </StyledTableCell>
                        <StyledTableCell align="center" className="table_content"
                        >
                          {row.payment_date}
                        </StyledTableCell>

                        <StyledTableCell align="center" className="table_content"
                        >
                          {row.issue_date}
                        </StyledTableCell>
                        <StyledTableCell align="center" className="table_content">
                          {row.issued_by_name}
                        </StyledTableCell>
                        {/* <StyledTableCell align="center" className="table_content">
                          {parseFloat(row.total_price.replace(/[₹,]/g, '')) || '0'}
                        </StyledTableCell> */}
                        <StyledTableCell align="center" className="table_content" >
                          {row.kit_status}
                        </StyledTableCell>
                        <StyledTableCell align="center" style={{ padding: "0" }}>

                          {row.kit_status === "Issued" ? (
                            <CheckBoxIcon
                              style={{ color: "rgb(143 134 134 / 87%)" }}
                            ></CheckBoxIcon>
                          ) : (
                            <Checkbox
                              checked={row.description === "Issued"}
                              disabled={row.description === "Issued"}
                              onChange={() => handleCheckboxClick(row)}

                            />
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="center" style={{ padding: "0" }}>
                          <ListAltIcon
                            className="product-icon"
                            style={{ marginLeft: 8, color: "#0A64A2" }}
                            onClick={(event) => {
                              event.stopPropagation(); // Stop click from triggering row click
                              handleProductList(row.kit_id);
                            }}
                          />
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <Button
                            variant="text"
                            className="receipt-icon"
                            startIcon={<DownloadIcon />}
                            style={{ padding: "0" }}
                            onClick={(event) => {
                              event.stopPropagation(); // Stop click from triggering row click
                              if (row.kit_status === "Paid" || row.kit_status === "Issued") {
                                handleDownloadReciept(row, event);
                              }
                            }}
                          />
                        </StyledTableCell>

                      </StyledTableRow>
                    ))}
                  </TableBody>
                )}
                <TableFooter className="table-footer">
                  <TableRow className="table-header">
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 20]}
                      count={sortedRows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      className="table-pagination"
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Box>


      {/* Product List Dialog */}
      <Dialog
        open={open}
        onClose={handleCloseProducts}
        maxWidth="lg"
        fullWidth={false}
        PaperProps={{
          style: {
            maxHeight: "90vh",
            boxShadow: "0",
          },
        }}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <IconButton
          onClick={handleCloseProducts}
          style={{
            color: "#817575",
            position: "absolute",
            right: "4px",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box>
          <DialogTitle
            style={{
              color: "#0A64A2",
              padding: "0px 11px", // Adjust padding for a more compact look
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0",
              marginTop: "15px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <ListAltIcon style={{ paddingBottom: "0", marginTop: "7px", }}
              />
              <span
                style={{
                  marginLeft: "4px",
                  fontWeight: "bold",
                  fontSize: "18px",
                  marginTop: "10px",
                }}
              >
              Product list for {kitName}
              </span>
            </div>
          </DialogTitle>
        </Box>
        <Divider
          className="divider"
          style={{ width: "96%", marginLeft: "13px" }}
        />
        <DialogContent
          style={{ padding: "0", margin: "0px 10px" }}
        >

          <div
            // key={type}
            style={{ marginBottom: "4px" }}
          >

            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell style={{ color: "#0A64A2", padding: "4px", }}> Sl.No</TableCell>
                  <TableCell style={{ color: "#0A64A2", padding: "4px", }}
                  > Product Name </TableCell>
                  <TableCell style={{ color: "#0A64A2", padding: "4px", }}
                  >Attribute </TableCell>

                  <TableCell style={{ color: "#0A64A2", padding: "4px", }}
                  >Quantity </TableCell>
                  <TableCell style={{ color: "#0A64A2", paddingLeft: "4px", }}
                  > Price
                  </TableCell>
                  <TableCell style={{ color: "#0A64A2", padding: "4px", }}
                  > Total Price </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(kitProducts?.kitProduct || []).map((p, index) => (
                  <TableRow key={p.product_id}>
                    <TableCell className="table-cell-product-list">{index + 1}</TableCell>
                    <TableCell align="left" style={{ padding: "4px" }}
                    > {p.product_name}
                    </TableCell>
                    <TableCell align="left" style={{ padding: "4px" }}
                    >{p.attribute_name} : {p.attribute_value}
                    </TableCell>

                    <TableCell align="center" style={{ padding: "4px" }}
                    >{p.quantity}
                    </TableCell>
                    <TableCell align="center" style={{ paddingLeft: "4px" }}
                    > {p.price}
                    </TableCell>
                    <TableCell align="center" style={{ padding: "4px" }}
                    > {p.price * p.quantity}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: "10px",
                fontWeight: "bold",
                fontSize: "0.9rem",
                marginTop: "5px",
              }}
            >
              <span
                style={{
                  color: "#0A64A2",
                }}
              >
                Total Price:
              </span>
              &nbsp;
              <span
                style={{ color: "rgb(58 48 48 / 87%)" }}
              >
                {totalProductPrice.toFixed(2)}
              </span>
            </div>
          </div>



          {/* Calculate total amounts for both issued and refunded products */}



        </DialogContent>
      </Dialog>
      <Snackbar
        open={showSnackbarMessage}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          setShowSnackbarMessage(false);
        }}
        message={snackbarMessage}
      >
        <Alert
          severity={snackbarMessageColor}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>






      <Dialog onClose={handleModelClose} maxWidth="xl" fullWidth open={isStoreOpen}>
        <DialogTitle ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleModelClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent style={{ padding: '25px', paddingTop: '0' }}>
          <KitPayment
            props={{
              studentId: selectedStudent?.id,
              studentName: selectedStudent?.name,
              role: selectedStudent?.role,
              section: selectedStudent?.section,
              grade: selectedStudent?.grade,
              refundBalance: refundBalance,
              setRefundBalance: setRefundBalance,
              academicYearId: academicYearId,
              gradeName: selectedStudent?.grade,
              userId: userId,
              assignedKitId: assignedKitId,
              kitId: selectedKit?.kit_id,
              total_price: parseFloat(selectedKit?.total_price?.replace(/[₹,]/g, '')) || null,
              sectionName: selectedStudent?.section,
              userMail: userMail,
              kitName: selectedKit?.kit_name,
              kit_stock: selectedKit?.kit_quantity,
              kitProductStock: kitProducts?.kitProduct || [],

            }}
          />
        </DialogContent>


      </Dialog>

      {/* check box  */}
      <Dialog
        open={checkBoxOpen}
        onClose={closeCheckBox}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
        <DialogContent
          style={{
            paddingLeft: dialogType === "confirmation" ? "15px" : "20px",
          }}
        >
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {dialogType === "confirmation" ? (
            <>
              <Button
                variant="contained"
                onClick={handleIssueKit}
                className="no-btn"
              >
                Yes
              </Button>
              <Button
                variant="contained"
                onClick={closeCheckBox}
                autoFocus
                className="no-btn"
              >
                No
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              onClick={closeCheckBox}
              autoFocus
              className="no-btn"
            >
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>

  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));